module.exports = __webpack_public_path__ + "static/l5-service-card1-b2a7485e3d556177bcb4a7f291cd586a.svg";